import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './Dot.less';

const cx = classnames.bind(styles);

export default React.memo(Dot);

Dot.propTypes = {
  /** Show as active */
  active: PropTypes.bool,
  /** The link target */
  href: PropTypes.string,
  /** A callback to call on click */
  onClick: PropTypes.func,
  /** Custom classnames for various states */
  classes: PropTypes.shape({
    active: PropTypes.string,
  }),
};

/** @Private */
function Dot({ active, classes, className, ...props }) {
  const { active: activeClass } = classes || {};
  const { disabled, href } = props;

  const customClass = activeClass ? { [activeClass]: active } : {};
  const isLink = !disabled && href !== '';
  const Tag = !isLink || href === '#' ? 'button' : 'a';

  if (Tag !== 'a') {
    delete props.href;
  }

  return (
    <Tag
      className={cx('dot', className, {
        active,
        ...customClass,
      })}
      {...props}
    >
      <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" width="12" height="12">
        <circle cx="50%" cy="50%" r="5" />
      </svg>
    </Tag>
  );
}
